import { getService } from '#root/store';

export const useTranslation = () => {
  return getService('translation').translateKey;
};
